import { render, staticRenderFns } from "./activitiesBanner.vue?vue&type=template&id=ebb7d204&scoped=true&"
import script from "./activitiesBanner.vue?vue&type=script&lang=ts&"
export * from "./activitiesBanner.vue?vue&type=script&lang=ts&"
import style0 from "./activitiesBanner.vue?vue&type=style&index=0&id=ebb7d204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb7d204",
  null
  
)

export default component.exports